import { FLIGHT_CHECK_ACTION, Service } from "@turizi/shared";

export const TransferTemplate: Partial<Service> = {
    category: 'transfer',
    required_service_orders: 1,

    self_attrs: [
        {
            key: 'origin_city',
            type: 'text',
            value: null,
            section: 'route_points_1',
            sort: 1,
            semibold: true,
        },
        {
            key: 'origin_zone',
            type: 'text',
            value: null,
            section: 'route_points_1',
            sort: 2,
            strong: true,
        },
        {
            key: 'destination_city',
            type: 'text',
            value: null,
            section: 'route_points_1',
            sort: 3,
            semibold: true,
        },
        {
            key: 'destination_zone',
            type: 'text',
            value: null,
            section: 'route_points_1',
            sort: 4,
            strong: true,
        },
        {
            key: 'round_trip',
            type: 'boolean',
            value: false,
            section: 'route_points_1',
            sort: 5,
        },
        {
            key: 'start_time',
            type: 'time',
            value: null,
            section: 'times_5',
            sort: 5,
        },
        {
            key: 'end_time',
            type: 'time',
            value: null,
            section: 'times_5',
            sort: 6,
        },
        {
            key: 'regular_schedule',
            type: 'boolean',
            value: true,
            section: 'scheduling_4',
            sort: 7,
        },
        {
            key: 'vehicle_type',
            type: 'text',
            value: null,
            section: 'vehicle_5',
            options: ['van', 'bus', 'minibus', 'car', 'bike', 'motorhome', 'truck', 'boat', 'other'],
            sort: 9,
        },
        {
            key: 'duration', // hours
            type: 'text',
            value: null,
            section: 'routing_3',
            sort: 12,
        },
    ],
    booking_attrs: [
        {
            key: 'origin_address',
            type: 'text',
            value: null,
            blocked: true,
            sort: 1,
            section: 'address_1',
        },
        {
            key: 'destination_address',
            type: 'text',
            value: null,
            blocked: true,
            sort: 2,
            section: 'address_1',
        },
        {
            key: 'flight_number',
            type: 'text',
            value: null,
            action: FLIGHT_CHECK_ACTION,
            blocked: true,
            sort: 3,
            section: '_2',
        },
        {
            key: 'bus_number',
            type: 'text',
            value: null,
            sort: 8,
            section: '_2',
        },
        {
            key: 'bus_brand',
            type: 'text',
            value: null,
            sort: 5,
            section: '_2',
        },
        {
            key: 'bus_departure_time',
            type: 'text',
            value: null,
            sort: 6,
            section: '_2',
        },
        {
            key: 'bus_arrival_time',
            type: 'text',
            value: null,
            sort: 7,
            section: '_2',
        },
        {
            key: 'bus_departure_location',
            type: 'text',
            value: null,
            sort: 8,
            section: '_2',
        },
        {
            key: 'bus_arrival_location',
            type: 'text',
            value: null,
            sort: 9,
            section: '_2',
        },

    ]

} as const;

export default TransferTemplate;

